<template>
    <div class="profile-header">
        <div class="col-md-12">
            <ul class="mb-0 p-0">
                <li v-if="showLocation">
                    <a href="#" @click.prevent="scrollToElement('#profile-map-section')">{{ translate.home.location }}</a>
                </li>
                <li v-if="showReviews">
                    <a href="#" @click.prevent="scrollToElement('#profile-reviews-section')">{{ translate.account.reviews.reviews }}</a>
                </li>
                <li v-if="showPrices">
                    <a href="#" @click.prevent="scrollToElement('#profile-prices-section')">{{ translate.account.prices }}</a>
                </li>
                <li v-else-if="showAbout">
                    <a href="#" @click.prevent="scrollToElement('#profile-about-section')">{{ translate.account.aboutMe }}</a>
                </li>
                <li v-if="showServices">
                    <a href="#" @click.prevent="scrollToElement('#profile-services-section')">{{ translate.home.services }}</a>
                </li>
                <li v-if="showTipMe">
                    <a href="#" @click.prevent="$emit('tip-click')" class="btn-tip-me-nav">
                        {{ translate.account.tips.tipMe }}
                        <CoinSolidComponent width="14px" height="14px"/>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import {scrollToElementSmooth} from "@/core/utils/helpers/scrollHelpers";
import CoinSolidComponent from "@/components/global/icons/CoinSolidComponent.vue";

export default {
    components: {CoinSolidComponent},
    props: {
        showLocation: {
            type: Boolean,
            default: false
        },
        showReviews: {
            type: Boolean,
            default: true
        },
        showAbout: {
            type: Boolean,
            default: false
        },
        showServices: {
            type: Boolean,
            default: false
        },
        showPrices: {
            type: Boolean,
            default: false
        },
        showTipMe: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        ...mapState(['translate'])
    },
    methods: {
        scrollToElement: scrollToElementSmooth
    }
}
</script>
